import store from '../'


const user = {
  namespaced: true,

  state: {
    users: [],
    isLoading: false,
  },

  actions: {
    getNickName({state, dispatch}, username) {
      return new Promise(async resolve => {
        if(state.users.length) {
          resolve(dispatch('toNickName', username))
        } else {
          if (state.isLoading) {
            // すでに読み込み中の場合は待つ
            const wait = (cnt = 0) => {
              if (state.isLoading && cnt < 600) {
                setTimeout(() => wait(cnt + 1), 100)
              } else {
                resolve(dispatch('toNickName', username))
              }
            }
            wait()
          } else {
            // まだ一度も読み込んでない場合は読み込んでから取得
            await dispatch('load')
            resolve(dispatch('toNickName', username))
          }
        }
      })
    },
    /**
     * ユーザー一覧の取得
     */
    async load({state, commit}) {
      commit('setLoading', true)
      await store.dispatch('auth/call', { api: 'getUserList' })
        .then(users => {
          commit('setUsers', users)
        })
        .catch(err => console.log(err))
      commit('setLoading', false)
    },
    /**
     * ユーザー一覧から指定したusername(ID)から氏名を取得
     */
    async toNickName({state, dispatch}, username) {
      if (!username) return ''

      const user = state.users.find(user => user.Username == username)
      if (user) {
        const name = user.Attributes.find(attr => attr.Name == 'name')
        if (name) return name.Value
      }
      return username
    },
  },

  mutations: {
    setLoading(state, isLoading) {
      state.isLoading = isLoading
    },
    setUsers(state, users) {
      state.users = users
    },
  }
}
export default user